// http://{root}/about
import Image from 'next/image'
import Head from 'next/head'
import Error from '../_error'
import { useSearchParams } from 'next/navigation'
export const metadata = {
	title: "Projects",
	description: "Generated by create next app",
};

export default function Projects() {
	const searchParams = useSearchParams()
	const statusCode = searchParams.get('statusCode')
	return (<>
		<Head>
			<title>Error: {metadata.title}</title>
		</Head>
		<Error statusCode={statusCode} />
	</>
  )
}
